import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ProductCategoryService } from '../services/productcategory.service';
import { ProductSpecpageModel } from '../models/product.specpage.model';
import { ProductCompatibleItemModel } from '../models/product.compatibleitem.model';
import { ExcelService } from '../services/excel.service';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { of } from 'rxjs'
import { environment } from '../../environments/environment';
import { SpinnerService } from '../services/spinner.service';


@Component({
  selector: 'app-specpage',
  templateUrl: './specpage.component.html',
  styleUrls: ['./specpage.component.css']
})
export class SpecpageComponent implements OnInit {
  productId: number;
  baseUrl = environment.baseUrl;
  i = 0;
  newIndex = 0;
  specpage: ProductSpecpageModel[] = [];
  compatibleitems: ProductCompatibleItemModel[] = [];
  nomenclature = '';
  casepacks = Array<string>();
  isPrinting = true;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ProductCategoryService,
    private excelService: ExcelService,
    private spinner: SpinnerService
  ) {

    this.productId = this.route.snapshot.params.productId;
  }
  ngOnInit(): void {
    this.spinner.showSpinner();
    this.service.getSpecpageData(this.productId)
      .subscribe(
        (data => {
          this.specpage = data;
          this.nomenclature = this.specpage[0].nomenclature;
          this.service.getSpecpageCompatibleItems(this.nomenclature)
            .subscribe(
              (data => {
                this.compatibleitems = data;
              })
            );
        }),
        (error => {
          //console.log(error);
          this.nomenclature = '';
        })
      );
    this.spinner.hideSpinner();
  }

  exportAsXLSX(): void {
    const excelData = this.specpage.map(function (obj) {
      return {
        nomenclature: obj.nomenclature,
        printgroup: obj.designName,
        title: obj.title,
        material: obj.material,
        lidColor: obj.lidColor,
        cupHeight: obj.cupHeight,
        flushFill: obj.flushFill,
        practicalFill: obj.practicalFill,
        widthatBottom: obj.widthatBottom,
        widthatRim: obj.widthatRim,
        itemDimensions: obj.itemDimensions,
        scc: obj.scc,
        upc: obj.upc,
        casePack: obj.casePack,
        weight: obj.weight,
        cube: obj.cube,
        length: obj.length,
        height: obj.height,
        width: obj.width,
        pallets: obj.pallets,
        ti: obj.ti,
        hi: obj.hi,
        sleeveQuantity: obj.sleeveQuantity,
        sleeves: obj.sleeves,
        part: obj.part

      };
    });
    this.excelService.exportAsExcelFile(excelData, 'specpage_data');
  }

  //***###Temporary Stuff. To be handled better in the next version. */
  public downloadSpec(id: number, nomenclature: string) {
    this.spinner.showSpinner();
    let filename = nomenclature + ".pdf";
    this.service.DownloadSpec(id)
      .subscribe(
        (response: any) => {
          let dataType = response.type;
          let binaryData = [];
          binaryData.push(response);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          if (filename)
            downloadLink.setAttribute('download', filename);
          document.body.appendChild(downloadLink);
          downloadLink.click();
        }
      )
    this.spinner.hideSpinner();
  }

  SwitchIndex(event: any) {
    this.i = event.target.value;
    //console.log(this.specpage[this.i]);
    //console.log(this.i);
  }


}






